<template>
    <div class="user-retreat-chart"></div>
</template>

<script>
import { mapState } from "vuex";
import { get } from "@/api/index";
import { deepClone } from "@/utils/common";
import { SELL_ICON_ECHART, BUY_ICON_ECHART } from "@/utils/constant";

export default {
    data: function () {
        return {
            chartDatas: '',
            myChartObj: '',
        }
    },
    props: [
        'myChartData',
        'sid',
        'timeCycle'
    ],
    mounted() {
        if (this.sid) {
            this.getChartData();
        }

        if (this.myChartData) {
            this.chartDatas = this.myChartData;
            this.createChart();
        }
    },
    computed: {
        ...mapState([
            'token'
        ])
    },
    watch: {
        sid: function () {
            this.getChartData();
        },
        myChartData: function () {
            this.chartDatas = this.myChartData;
            if (this.myChartObj) {
                this.myChartObj.clear();
            }
            this.createChart();
        }
    },
    methods: {
        // 创建图表
        createChart() {
            var myChart = this.$echarts.init(this.$el);
            this.myChartObj = myChart;
            var that = this;
            var axisColor = '#a8a7a9';
            var startCount = 0;
            var chart_split_color = '#3f3f42';

            if (this.timeCycle.indexOf('D') == -1) {
                if (this.chartDatas.createtime.length > 120) {
                    startCount = (100 - 120 / this.chartDatas.createtime.length * 100).toFixed(0);
                }
            }

            // 交易数据处理
            var ori_arr = deepClone(this.chartDatas.down_direction);
            var down_handle_data = [];

            ori_arr.forEach((value, index) => {
                var i_data = Number(value);
                var i_obj = {
                    coord: [index, this.chartDatas.market[index]+1],
                    name: '信号',
                    symbolOffset: [0, '10%'],
                };
                var i_color, i_symbol;

                if (i_data > 0) {// 买
                    i_color = '#198965';
                    i_symbol = BUY_ICON_ECHART;
                } else if (i_data < 0) {
                    i_color = '#db5634';
                    i_symbol = SELL_ICON_ECHART;
                }

                if (i_data !== 0) {
                    i_obj['itemStyle'] = {color: i_color};
                    i_obj['symbol'] = i_symbol;
                    down_handle_data.push(i_obj);
                } 
            })
            
            var ori_arr_up = deepClone(this.chartDatas.up_direction);
            ori_arr_up.forEach((value, index) => {
                var j_obj = {
                    coord: [index, this.chartDatas.market[index]-1],
                    name: '信号',
                    symbolOffset: [0, '-10%'],
                };
                var j_color, j_symbol;

                if (value > 0) {// 买
                    j_color = '#198965';
                    j_symbol = BUY_ICON_ECHART;
                } else if (value < 0) {
                    j_color = '#db5634';
                    j_symbol = SELL_ICON_ECHART;
                }

                if (value !== 0) {
                    j_obj['itemStyle'] = {color: j_color};
                    j_obj['symbol'] = j_symbol;
                    down_handle_data.push(j_obj);
                }
            })

            var options  = {
                tooltip: {
                    position: function() {
                        return {right: 0, top: 0};
                    },
                    enterable: true,
                    axisPointer: {
                        type: 'line',
                        animation: false
                    },
                    trigger: 'axis',
                    formatter: function (param) {
                        var li_str = '';
                        for (var i=0; i<param.length; i++) {
                            var i_data = param[i];
                            var i_strs = '';
                            if (i_data.seriesIndex == 2) {
                                i_strs = '<li style="display: flex; justify-content: space-between;"><span>'+i_data.marker+i_data.seriesName+
                                '：</span><span>'+Number(i_data.data).toFixed(2)+'%</span></li>';
                            } else {
                                i_strs = '<li style="display: flex; justify-content: space-between;"><span>'+i_data.marker+i_data.seriesName+
                                '：</span><span>'+i_data.data+'%</span></li>';
                            }
                            li_str += i_strs;
                        }
                        var price_str;
                        if (that.chartDatas.price.length > 0) {
                             price_str= '<li style="display: flex; justify-content: space-between;"><span>价格数字</span><span>'+
                            that.chartDatas.price[param[0].axisIndex]+'</span></li>';
                        } else {
                            price_str = '';
                        }

                        var tip_html = '<ul style="padding: 10px; border-box: 0 2px 8px rgba(0, 0, 0, 0.5);"><li>时间：'+param[0].axisValue+'</li>'+ li_str +
                        price_str+'</ul>';
                        return tip_html;
                    },
                    backgroundColor: "rgba(29, 44, 58, 0.5)",
                    label: {
                        show: true
                    }
                },
                backgroundColor: "#2a2d2e",
                textStyle: {
                    color: "#a8a7a9"
                },
                color: ['#db5634', '#17966d', '#8c7d25', '#752275', '#0a3c6b'],
                dataZoom: [{
                    type: 'inside', 
                    xAxisIndex: [0, 1, 2, 3, 4],
                    start: startCount,
                    end: 100
                }, {
                    type: 'slider',
                    xAxisIndex: [0, 1, 2, 3, 4],
                    start: startCount,
                    end: 100,
                    borderColor: '#4b4b4e',
                    textStyle: {
                        color: axisColor
                    },
                    dataBackground: {
                        lineStyle: {

                        },
                        areaStyle: {
                            color: '#999'
                        }
                    }
                }],
                grid: [
                    {x: 60, y: 40, width: "90%", height: 300,},
                    {x: 60, y: 40, width: "90%", height: 300, borderColor: '#4b4b4e', show: true,},
                    {x: 60, y: 70+300, width: "90%", height: 100, borderColor: '#4b4b4e', show: true,},
                    {x: 60, y: 70+300, width: "90%", height: 100, borderColor: '#4b4b4e', show: true},
                    {x: 60, y: 70+400, width: "90%", height: 70, borderColor: '#4b4b4e', show: true,},
                ],
                xAxis: [
                    { gridIndex: 0, type: 'category', data: this.chartDatas.createtime, show: true },
                    { gridIndex: 1, type: 'category', data: this.chartDatas.createtime, show: false },
                    { gridIndex: 2, type: 'category', data: this.chartDatas.createtime, 
                        axisLine: {
                            lineStyle: {
                                color: '#5a595a'
                            }
                        },
                        axisLabel: {
                            textStyle: {
                                color: '#4b4b4e'
                            }
                        },
                        show: false,
                        axisPointer: {
                            label: {
                                show: false
                            }
                        },
                        scale: true
                    },
                    { gridIndex: 3, type: 'category', data: this.chartDatas.createtime, show: false, 
                        axisPointer: {
                            label: {
                                show: false
                            }
                        },
                        
                    },
                    { gridIndex: 4, type: 'category', data: this.chartDatas.createtime, show: false, 
                        axisPointer: {
                            label: {
                                show: false
                            }
                        },
                     },
                ],
                yAxis: [
                    {
                        position: 'right',
                        name: '收益',
                        gridIndex: 0,
                        type: 'value',
                        axisLabel: {
                            formatter: '{value} %',
                            textStyle: {
                                color: '#4b4b4e'
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: chart_split_color,
                                type: 'dashed'
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: chart_split_color
                            }
                        }
                    },
                    {
                        // position: 'right',
                        // name: '价格走势',
                        gridIndex: 1,
                        type: 'value',
                        axisLabel: {
                            formatter: '{value} %',
                            textStyle: {
                                color: '#4b4b4e'
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: chart_split_color,
                                type: 'dashed'
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: chart_split_color
                            }
                        },
                        nameTextStyle: {
                            align: 'right'
                        }
                    },
                    {
                        position: 'right',
                        name: '回撤',
                        gridIndex: 2,
                        type: 'value',
                        axisLabel: {
                            formatter: '{value} %',
                            textStyle: {
                                color: '#4b4b4e'
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: chart_split_color,
                                type: 'dashed'
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: chart_split_color
                            }
                        },
                        inverse: true,
                        nameTextStyle: {
                            align: 'left',
                            padding: [0, 0, 0, 20]
                        },
                        nameLocation: 'start',
                        nameGap: '-5'
                    },
                    {
                        // position: 'right',
                        // name: '价格数字',
                        gridIndex: 3,
                        type: 'value',
                        axisLabel: {
                            formatter: '{value}',
                            textStyle: {
                                color: '#4b4b4e'
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#4b4b4e',
                                type: 'dashed'
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#4b4b4e'
                            }
                        },
                        inverse: true,
                        nameTextStyle: {
                            align: 'right'
                        }
                    },
                    {
                        name:'持仓',
                        gridIndex: 4,
                        type: 'value',
                        axisLabel: {
                        formatter: "{value} %",
                            textStyle: {
                                color: '#4b4b4e'
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#3f3f40',
                                type: 'dashed'
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#4b4b4e'
                            }
                        },
                        minorTick: {
                            splitNumber: 3
                        },
                        nameTextStyle: {
                            align: 'right',
                            padding: [0, 25, 0, 0]
                        },
                        nameLocation: 'start',
                        nameGap: '-2'
                    }
                ],
                axisPointer: {
                    link: [
                        {xAxisIndex: 'all'}
                    ],
                    label: {
                        backgroundColor: '#777',
                        formatter: function (e) {
                            if (e.axisDimension == 'x') {
                                return e.value;
                            }
                            return (e.value).toFixed(2) + '%';
                        } 
                    }
                },
                series: [{
                    type: 'line',
                    name: '收益',
                    data: this.chartDatas.earnings,
                    xAxisIndex: 0,
                    yAxisIndex: 0,
                    symbol: 'none',
                    lineStyle: {
                        width: 1,
                    },
                    areaStyle: {
                        normal: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgba(219, 86, 52, 0.4)'
                            },{
                                offset: 1,
                                color: 'rgba(219, 86, 52, 0.4)',
                            }], false),
                        }
                    },
                    marketPoint: {
                        symbolSize: [10, 10],
                        data: [
                            {name: '最大值', type: 'max', symbol: 'triangle'}
                        ]
                    }
                }, {
                    type: 'line',
                    name: '价格走势',
                    // data: this.chartDatas.market,
                    xAxisIndex: 1,
                    yAxisIndex: 1,
                    symbol: 'none',
                    lineStyle: {
                        width: 1,
                    },
                }, {
                    type: 'line',
                    name: '回撤',
                    data: this.chartDatas.drawdown,
                    xAxisIndex: 2,
                    yAxisIndex: 2,
                    symbol: 'none',
                    lineStyle: {
                        width: 2,
                    },
                }, {
                    type: 'line',
                    name: '价格数字',
                    // data: this.chartDatas.price,
                    xAxisIndex: 3,
                    yAxisIndex: 3,
                    symbol: 'none',
                    lineStyle: {
                        width: 2,
                    },
                },
                {
                    type: 'bar',
                    name: '持仓',
                    barWidth: 3,
                    data: this.chartDatas.position,
                    xAxisIndex: 4,
                    yAxisIndex: 4,
                    animation: false
                }
                ]
            };

            myChart.setOption(options);
        },

        // 获取图表数据
        getChartData() {
            let url = this.$url_LN_local + '/get/chart/data';
            var s_list = [];
            s_list.push(this.sid);
            let param = {
                'sign': JSON.stringify(s_list),
                'token': this.token
            };

            get(url, param).then(res => {
                if (res.code === 200) {
                    this.chartData = res.data[this.sid];
                    // this.createChart();
                } else {
                    this.$notify.error({
                        message: res.info,
                        title: '提示',
                        offset: 100
                    })
                }
            })
        },

        // 设置load img
        setChartLoading(flag) {
            
            if (flag == 'show') {
                this.myChartObj.showLoading({
                    maskColor: 'rgba(0, 0, 0, 0.8)',
                    text: 'loading...',
                    textColor: '#999'
                });
            } else if (flag == 'hide') {
                if (this.myChartObj) {
                    this.myChartObj.hideLoading();
                }
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.user-retreat-chart {
    width: 100%;
    height: 620px;
    .chart-tip-left {
        float: left;
        min-width: 60px;
    }

    .chart-tip-right {
        float: right;
    }
}
</style>
